import { CraSimulateResults } from "@keita/lanepatrol-sdk";
import { CraSimulatedResult } from "../../survey/models/CraForecastScenario";
import {
  jwtAuthAxios,
  optionalAuthAxios,
} from "../../shared/utils/network-utils";
import {
  CraNodeCoding,
  CreateOrUpdateCraNodeCoding,
} from "../models/CraNodeCoding";

export const CraNodeCodingApi = {
  batchUpdate: async (codingEntries: CreateOrUpdateCraNodeCoding[]) => {
    return await jwtAuthAxios().put<CraNodeCoding[]>(
      `/cra-node-coding`,
      codingEntries
    );
  },

  simulateResults: async (body: CraSimulateResults) => {
    return await optionalAuthAxios().post<CraSimulatedResult[]>(
      `/cra-node-coding/simulate-results`,
      body
    );
  },
};
